document.addEventListener('DOMContentLoaded', () => {
  const personalizations = Array.from(document.querySelectorAll('.cc-personalization'));
  if (personalizations.length === 0) return;

  personalizations.forEach((personalization) => {
    const formId = personalization.getAttribute('data-product-form-id');
    const nameInput = personalization.querySelector('input[data-cc-name]');
    if (!formId || !nameInput) return;

    const form = document.getElementById(formId);

    const addButtons = Array.from(
      document.querySelectorAll(
        `button[name="add"][form="${formId}"], button[type="submit"][form="${formId}"]`
      )
    );

    if (addButtons.length === 0 && form) {
      addButtons.push(...Array.from(form.querySelectorAll('button[name="add"], button[type="submit"]')));
    }

    const hasName = () => (nameInput.value || '').trim().length > 0;

    const setState = () => {
      const ok = hasName();
      addButtons.forEach((btn) => {
        btn.disabled = !ok;
        btn.setAttribute('aria-disabled', String(!ok));
      });
    };

    setState();
    nameInput.addEventListener('input', setState);
    nameInput.addEventListener('change', setState);

    if (form) {
      form.addEventListener(
        'submit',
        (e) => {
          if (!hasName()) {
            e.preventDefault();
            e.stopPropagation();
            nameInput.focus();
            nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        },
        true
      );
    }

    addButtons.forEach((btn) => {
      btn.addEventListener(
        'click',
        (e) => {
          if (!hasName()) {
            e.preventDefault();
            e.stopPropagation();
            nameInput.focus();
            nameInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setState();
          }
        },
        true
      );
    });
  });
});